// src/utils/exportService.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportToPDF = (title = 'Report', columns = [], data = [], filename = 'report.pdf') => {
  const doc = new jsPDF();
  doc.text(title, 14, 10);
  autoTable(doc, {
    startY: 20,
    head: [columns],
    body: data,
  });
  doc.save(filename);
};

export const generateCSVData = (columns, data) => {
  return [columns, ...data];
};

export const printTableFromHtml = (html, title = 'Print Report') => {
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
        </style>
      </head>
      <body>
        <h2>${title}</h2>
        ${html}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
